// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from 'firebase/auth'; // Import getAuth
import { getAnalytics, isSupported } from "firebase/analytics";
import { getDatabase } from 'firebase/database';
import { getFirestore } from 'firebase/firestore';

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCiFz-zC1mZ3obkDs9y704lG-dTyU7yyH4",
  authDomain: "craft---the-social-beer-6b1e6.firebaseapp.com",
  databaseURL: "https://craft---the-social-beer-6b1e6-default-rtdb.firebaseio.com",
  projectId: "craft---the-social-beer-6b1e6",
  storageBucket: "craft---the-social-beer-6b1e6.appspot.com",
  messagingSenderId: "333584915354",
  appId: "1:333584915354:web:9aac239c6aec9f61eaf823",
  measurementId: "G-6HKYZ2X2E8"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Keep local previews from sending analytics traffic or surfacing blocked
// third-party script errors in the React development overlay. Production
// browsers still initialize Analytics when the SDK reports support.
if (process.env.NODE_ENV === "production") {
  isSupported()
    .then((supported) => {
      if (supported) {
        getAnalytics(app);
      }
    })
    .catch(() => {
      // Analytics is optional and should never prevent the app from loading.
    });
}

// Get the Auth service for the default app
const auth = getAuth(app);

export { auth }; // Export the auth object
// Initialize Firebase Database
const database = getDatabase(app);

export { database }; // Export the database object

const firestore = getFirestore(app);

export { firestore }; // Export the firestore object
